const scrollLock = window.themeVendor.ScrollLock;

window.theme.windowWidth = getWindowWidth();
window.theme.windowHeight = getWindowHeight();
window.theme.isMobile = isMobile();

let lastScale = window.visualViewport ? window.visualViewport.scale : 1;

function dispatch$1() {
  // Update isMobile state before dispatching event
  const currentMediaQuery = isMobile();
  if (window.theme.isMobile !== currentMediaQuery) {
    window.theme.isMobile = currentMediaQuery;
  }

  const currentWidth = getWindowWidth();
  const currentHeight = getWindowHeight();

  if (window.theme.windowWidth !== currentWidth) {
    document.dispatchEvent(new CustomEvent('theme:resize:width', { bubbles: true }));
    window.theme.windowWidth = currentWidth;
  }

  if (window.theme.windowHeight !== currentHeight) {
    document.dispatchEvent(new CustomEvent('theme:resize:height', { bubbles: true }));
    window.theme.windowHeight = currentHeight;
  }

  document.dispatchEvent(new CustomEvent('theme:resize', { bubbles: true }));
}

export function resizeListener() {
  window.addEventListener(
    'resize',
    window.theme.debounce(function () {
      // Check if viewport is zoomed (scaled)
      const currentScale = window.visualViewport ? window.visualViewport.scale : 1;
      const zooming = Math.abs(currentScale - lastScale) > 0.05;

      if (zooming) {
        // Zoom detected — ignore resize
        lastScale = currentScale;
        return;
      }

      lastScale = currentScale;

      dispatch$1();
    }, 50)
  );
}

function getWindowWidth() {
  return document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;
}

function getWindowHeight() {
  return document.documentElement.clientHeight || document.body.clientHeight || window.innerHeight;
}

function isMobile() {
  return window.innerWidth < theme.sizes.small;
}

let prev = window.scrollY;
let up = null;
let down = null;
let wasUp = null;
let wasDown = null;
let scrollLockTimer = 0;

function dispatch() {
  const position = window.scrollY;
  if (position > prev) {
    down = true;
    up = false;
  } else if (position < prev) {
    down = false;
    up = true;
  } else {
    up = null;
    down = null;
  }
  prev = position;
  document.dispatchEvent(
    new CustomEvent('theme:scroll', {
      detail: {
        up,
        down,
        position,
      },
      bubbles: false,
    })
  );
  if (up && !wasUp) {
    document.dispatchEvent(
      new CustomEvent('theme:scroll:up', {
        detail: { position },
        bubbles: false,
      })
    );
  }
  if (down && !wasDown) {
    document.dispatchEvent(
      new CustomEvent('theme:scroll:down', {
        detail: { position },
        bubbles: false,
      })
    );
  }
  wasDown = down;
  wasUp = up;
}

function lock(e) {
  // Prevent body scroll lock race conditions
  setTimeout(() => {
    if (scrollLockTimer) {
      clearTimeout(scrollLockTimer);
    }

    scrollLock.disablePageScroll(e.detail, {
      allowTouchMove: (el) => el.tagName === 'TEXTAREA',
    });

    document.documentElement.setAttribute('data-scroll-locked', '');
  });
}

function unlock(e) {
  const timeout = e.detail;

  if (timeout) {
    scrollLockTimer = setTimeout(removeScrollLock, timeout);
  } else {
    removeScrollLock();
  }
}

function removeScrollLock() {
  scrollLock.clearQueueScrollLocks();
  scrollLock.enablePageScroll();
  document.documentElement.removeAttribute('data-scroll-locked');
}

export function scrollListener() {
  let timeout;
  window.addEventListener(
    'scroll',
    function () {
      if (timeout) {
        window.cancelAnimationFrame(timeout);
      }
      timeout = window.requestAnimationFrame(function () {
        dispatch();
      });
    },
    { passive: true }
  );

  window.addEventListener('theme:scroll:lock', lock);
  window.addEventListener('theme:scroll:unlock', unlock);
}
